const page_schema = {
	"tiers": [
		{
			"name": "Analysis",
			"type": "checkbox",
			"id": "analysis",
			"class_name": "tags",
			"child_name": "analysi",
			"options": [
				{
					"name": "DNA/RNA Methylation (5-mC)",
					"id": "dna-rna-methylation-(5-mc)"
				},
				{
					"name": "5-hmC",
					"id": "5-hmc"
				},
				{
					"name": "Chromatin",
					"id": "chromatin"
				},
			]
		},
		{
			"name": "Feature",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "Bisulfite Method",
					"id": "bisulfite-method"
				},
				{
					"name": "Non-bisulfite Method",
					"id": "non-bisulfite-method"
				},
				{
					"name": "NGS Library Prep",
					"id": "ngs-library-prep"
				},
				{
					"name": "DNA Methylation Standard",
					"id": "dna-methylation-standard"
				},
				{
					"name": "Antibody",
					"id": "antibody"
				},
				{
					"name": "Enzyme",
					"id": "enzyme"
				},
			]
		},
		{
			"name": "Format",
			"type": "checkbox",
			"id": "formats",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "Column",
					"id": "column"
				},
				{
					"name": "Spin Plate",
					"id": "spin-plate"
				},
				{
					"name": "MagBead",
					"id": "magbead"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"Zymo-Seq Trio WGBS Library Kit": {
			"title": "Zymo-Seq Trio WGBS Library Kit",
			"catalogNumbers": "D5462, D5463",
			"description": "The Zymo-Seq Trio WGBS Library Kit offers an optimized and reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation from cell-free DNA (cfDNA), FFPE DNA, and gDNA.",
			"handle": "/products/zymo-seq-trio-wgbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg?v=1642623540&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-trio-wgbs-library-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"ngs-library-prep",
			],
			filters: []
		},
		"Zymo-Seq WGBS Library Kit": {
			"title": "Zymo-Seq WGBS Library Kit",
			"catalogNumbers": "D5465",
			"description": "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube.",
			"handle": "/products/zymo-seq-wgbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5465-zymo_seq_wgbs_library_kit.jpg?v=1628632445&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-wgbs-library-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"ngs-library-prep",
			],
			filters: []
		},
		"EZ DNA Methylation-Lightning Automation Kit": {
			"title": "EZ DNA Methylation-Lightning Automation Kit",
			"catalogNumbers": "D5049",
			"description": "The EZ DNA Methylation-Lightning Automation Kit is a high-throughput DNA bisulfite conversion kit designed for streamlining automation workflows.",
			"handle": "/collections/ez-dna-methylation-lightning-kits/products/ez-dna-methylation-lightning-automation-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5049-ez_dna_methylation_lightning_automation_kit.jpg?v=1633408988&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-lightning-automation-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"magbead",
			],
			filters: []
		},
		"EZ DNA Methylation-Lightning Kit": {
			"title": "EZ DNA Methylation-Lightning Kit",
			"catalogNumbers": "D5030-E, D5031-E, D5030T, D5030, D5031",
			"description": "The EZ DNA Methylation-Lightning Kit can rapidly bisulfite convert and purify DNA in less than 1.5 hours. A ready-to-use conversion reagent streamlines this process – simply add the reagent directly to the sample and incubate. Desulphonation and clean-up of the converted DNA is performed on a spin-column, allowing an elution volume as low as 10 µl. The kit achieves high conversion efficiency of unmodified cytosines into uracil, ensuring accurate downstream methylation analysis.",
			"handle": "/collections/ez-dna-methylation-lightning-kits/products/ez-dna-methylation-lightning-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg?v=1632263439&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-lightning-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"column",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Lightning Kit": {
			"title": "EZ-96 DNA Methylation-Lightning Kit",
			"catalogNumbers": "D5032, D5033",
			"description": "The EZ-96 DNA Methylation-Lightning Kit is a rapid, high-throughput (96-well) bisulfite conversion kit for DNA methylation analysis. The streamlined workflow features ready-to-use Lightning Conversion Reagent and a combined DNA denaturation and bisulfite conversion process. Desulphonation and clean-up of the converted DNA is performed using a unique 96-well spin-plate. With the Deep-Well Kit (Cat. D5033), samples can be eluted in as little as 15 µl. High yield, converted DNA is ideal for PCR, array, and Next-Generation sequencing, etc.",
			"handle": "/collections/ez-dna-methylation-lightning-kits/products/ez-96-dna-methylation-lightning-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5032_EZ-96-DAN-Methylation-Lightning-Kit-Shallow-Well_8a88a685-b5c4-48bd-a549-d70384045426.jpg?v=1632268109&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-lightning-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"spin-plate",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Lightning MagPrep": {
			"title": "EZ-96 DNA Methylation-Lightning MagPrep",
			"catalogNumbers": "D5046, D5047, D5046-E, D5047-E",
			"description": "The EZ DNA Methylation-Lightning magbead based Kits are the fastest magnetic bead-based DNA bisulfite conversion kit for high-throughput and automated methylation analysis. No preparation is necessary with the ready-to-use conversion reagent - simply add this unique reagent to a DNA sample and incubate the reaction for about one hour. Desulphonation and clean-up of the converted DNA is performed while bound to the MagBinding Beads. This magnetic bead-based bisulfite conversion kit produces the highest yields of bisulfite-converted DNA that is ideal for PCR, arrays, library preps, and Next-Generation sequencing.",
			"handle": "/collections/ez-dna-methylation-lightning-kits/products/ez-96-dna-methylation-lightning-magprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5046-E_EZ-96-DNA-Methylation-Lightning-MagPrep_4e8e4b9b-86d1-4c0f-bce8-abe88db4135a.jpg?v=1676054453&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-lightning-magprep",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"magbead",
			],
			filters: []
		},
		"EZ DNA Methylation-Direct Kit": {
			"title": "EZ DNA Methylation-Direct Kit",
			"catalogNumbers": "D5021, D5020",
			"description": "The EZ DNA Methylation-Direct kit is a bisulfite conversion kit that features reliable and complete DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. The increased sensitivity of this bisulfite conversion kit makes it possible to amplify bisulfite-converted DNA from as few as 10 cells or 50 pg DNA. Recovered bisulfite-converted DNA is ideal for downstream analyses including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-direct-kits/products/ez-dna-methylation-direct-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5020_EZ-DNA-Methylation-Direct-Kit-Column.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-direct-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"column",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Direct Kit": {
			"title": "EZ-96 DNA Methylation-Direct Kit",
			"catalogNumbers": "D5023, D5022",
			"description": "The EZ-96 DNA Methylation-Direct Kit is a 96-well bisulfite conversion kit that features reliable and complete DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. The increased sensitivity of this 96-well bisulfite conversion kit makes it possible to amplify bisulfite-converted DNA from as few as 10 cells or 50 pg DNA. Recovered bisulfite-converted DNA is ideal for PCR amplification for downstream analyses including restriction endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-direct-kits/products/ez-96-dna-methylation-direct-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5022_EZ-96-DNA-Methylatoin-Direct-Kit-Shallow-Well.jpg?v=1628532411&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-direct-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"spin-plate",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Direct MagPrep": {
			"title": "EZ-96 DNA Methylation-Direct MagPrep",
			"catalogNumbers": "D5045, D5044",
			"description": "The EZ-96 DNA Methylation-Direct MagPrep is a magnetic bead-based bisulfite conversion kit that allows simple and reliable DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. The increased sensitivity of this magnetic bead-based bisulfite conversion kit makes it possible to amplify bisulfite-converted DNA from as few as 10 cells or 50 pg DNA. These innovations have been coupled to a magnetic bead-based clean-up for high-throughput methylation analysis. Desulphonation and clean-up of the converted DNA is performed while bound to the MagBinding Beads. This magnetic bead based bisulfite conversion kit has been designed to minimize template degradation, loss of DNA during treatment and clean-up, and to provide complete conversion of unmethylated cytosines. Recovered DNA is ideal for downstream analyses, including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-direct-kits/products/ez-96-dna-methylation-direct-magprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5044-EZ-96-Methylation-Lightning-Direct.jpg?v=1628532392&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-direct-magprep",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"magbead",
			],
			filters: []
		},
		"EZ DNA Methylation Kit": {
			"title": "EZ DNA Methylation Kit",
			"catalogNumbers": "D5001, D5002",
			"description": "The EZ DNA Methylation Kit features a simplified procedure that streamlines bisulfite treatment of DNA. This kit is the original bisulfite conversion kit from Zymo Research. The EZ DNA Methylation Kit is based on the three-step reaction that takes place between cytosine and sodium bisulfite during which cytosine is converted into uracil. Innovative desulphonation technologies eliminate otherwise cumbersome precipitations. The kit is designed to reduce template degradation and minimize DNA loss during treatment and clean-up, while ensuring complete conversion of the DNA. Purified, converted DNA is ideal for downstream analyses including library preparation for Next-generation sequencing, PCR amplification, endonuclease digestion, sequencing, microarrays, etc. The EZ DNA Methylation Kit is recommended for use with Illumina Infinium MethylationEPIC BeadChip array.",
			"handle": "/collections/ez-dna-methylation-kits/products/ez-dna-methylation-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5001_EZ-DNA-Methylation-Kit.jpg?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"column",
			],
			filters: []
		},
		"EZ-96 DNA Methylation Kit": {
			"title": "EZ-96 DNA Methylation Kit",
			"catalogNumbers": "D5004, D5003",
			"description": "The EZ-96 DNA Methylation Kits are bisulfite conversion kits that feature a high-throughput (96-well spin-plate), simplified procedure that streamlines bisulfite conversion of DNA. Cytosines undergo a three-step reaction with sodium bisulfite during which the cytosine is converted into uracil. The innovative in-column desulphonation technology eliminates otherwise cumbersome precipitations. The kit is designed to reduce template degradation and minimize DNA loss during treatment and clean-up, while ensuring complete conversion of the DNA. Purified, converted DNA is ideal for downstream analyses including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-kits/products/ez-96-dna-methylation-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5003-EZ-96-DNA-Methylation-Kit---shallow-well.png?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"spin-plate",
			],
			filters: []
		},
		"EZ-96 DNA Methylation MagPrep": {
			"title": "EZ-96 DNA Methylation MagPrep",
			"catalogNumbers": "D5040, D5041",
			"description": "The EZ-96 DNA Methylation MagPrep is a bisulfite conversion kit that features a high-throughput (96-well), simplified procedure that streamlines bisulfite conversion of DNA. The kit is based on the three-step reaction that takes place between cytosine and sodium bisulfite during which cytosine is converted into uracil. Desulphonation and clean-up of the converted DNA is performed while bound to the MagBinding Beads. The kit is designed to reduce template degradation and minimize DNA loss during treatment and clean-up, while ensuring complete conversion of the DNA. Purified, converted DNA is ideal for downstream analyses including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-kits/products/ez-96-dna-methylation-magprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg?v=1628532410&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-magprep",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"magbead",
			],
			filters: []
		},
		"EZ DNA Methylation-Gold Kit": {
			"title": "EZ DNA Methylation-Gold Kit",
			"catalogNumbers": "D5006, D5005",
			"description": "The EZ DNA Methylation-Gold Kit is a refinement of our popular EZ DNA Methylation kit and uses heat denaturation instead of chemical denaturation of the input DNA. This allows for the denaturation and bisulfite conversion steps to be consolidated into one step, leading to a much-reduced incubation time. Recovered bisulfite-converted DNA is ideal for PCR amplification for downstream analyses including endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-gold-kits/products/ez-dna-methylation-gold-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5005_EZ-DNA-Methylation-Gold-Kit.jpg?v=1628532410&width=600",
			"generalIndex": "998",
			"id": "ez-dna-methylation-gold-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"column",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Gold Kit": {
			"title": "EZ-96 DNA Methylation-Gold Kit",
			"catalogNumbers": "D5008, D5007",
			"description": "The EZ-96 DNA Methylation-Gold Kit allows high-throughput (96-well spin-plate) conversion of unmethylated cytosines into uracil in less than 3 hours. Our optimized bisulfite chemistry combines heat denaturation and bisulfite conversion of input DNA to reduce incubation time and ensure conversion rates >99%. Recovered bisulfite-converted DNA is ideal for PCR amplification for downstream analyses including endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-gold-kits/products/ez-96-dna-methylation-gold-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5007_EZ-DNA-Methylation-Gold-Kit.jpg?v=1628532400&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-gold-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"spin-plate",
			],
			filters: []
		},
		"EZ-96 DNA Methylation-Gold MagPrep": {
			"title": "EZ-96 DNA Methylation-Gold MagPrep",
			"catalogNumbers": "D5042, D5043",
			"description": "The EZ-96 DNA Methylation-Gold MagPrep integrates DNA denaturation and bisulfite conversion processes into one step followed by a magnetic bead-based clean-up for high-throughput methylation analysis. To streamline the procedure, high temperature is used instead of sodium hydroxide to denature DNA. Desulphonation and clean-up of the converted DNA is performed while bound to the MagBinding Beads. The EZ DNA Methylation-Gold kits have been designed to minimize template degradation, loss of DNA during treatment and clean-up, and to provide complete conversion of unmethylated cytosines. Recovered DNA is ideal for downstream analyses, including PCR amplification, endonuclease digestion, sequencing, microarrays, etc.",
			"handle": "/collections/ez-dna-methylation-gold-kits/products/ez-96-dna-methylation-gold-magprep",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg?v=1628532384&width=600",
			"generalIndex": "998",
			"id": "ez-96-dna-methylation-gold-magprep",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"magbead",
			],
			filters: []
		},
		"Pico Methyl-Seq Library Prep Kit": {
			"title": "Pico Methyl-Seq Library Prep Kit",
			"catalogNumbers": "D5455, D5456",
			"description": "The Pico Methyl-Seq Library Prep Kit provides a streamlined workflow for making WGBS libraries. Input DNA is randomly fragmented during the initial bisulfite treatment step followed by three rounds of amplification with uniquely designed primers. The procedure can accommodate as little as 10 pg input DNA (including that derived from FFPE samples), making it ideal for methylation analysis of precious, limited, and target-enriched samples.",
			"handle": "/products/pico-methyl-seq-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5456_pico-methyl-seq-library-prep-kit_1.jpg?v=1628532385&width=600",
			"generalIndex": "998",
			"id": "pico-methyl-seq-library-prep-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"ngs-library-prep",
			],
			filters: []
		},
		"Zymo-Seq RRBS Library Kit": {
			"title": "Zymo-Seq RRBS Library Kit",
			"catalogNumbers": "D5460, D5461",
			"description": "Zymo-Seq RRBS Library Kit is an all-in-one RRBS library prep kit that generates NGS libraries with a simplified workflow for the classic method Reduced Representation Bisulfite Sequencing (RRBS). This all-in-one RRBS library prep kit allows for DNA methylation profiling at single-nucleotide resolution in CpG-rich regions of the genome.",
			"handle": "/products/zymo-seq-rrbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5460_ez_dna_methylation_rrbs_library_prep_kit_3045e660-6901-4f39-bdf2-0a00421995b9.png?v=1628706203&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-rrbs-library-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"bisulfite-method",
				"ngs-library-prep",
			],
			filters: []
		},
		"5-mC DNA ELISA Kit": {
			"title": "5-mC DNA ELISA Kit",
			"catalogNumbers": "D5325, D5326",
			"description": "The 5-mC DNA ELISA Kit allows researchers to accurately quantitate 5-mC in any DNA sample in less than 3 hours. The kit features an Anti-5-Methylcytosine monoclonal antibody that is both sensitive and specific for 5-mC. The assay is compatible with a wide range of input DNA from vertebrate, plant, and microbial sources as well as methylated PCR amplicons and fragmented DNA. Percent 5-mC in a DNA sample can be accurately quantified from a standard curve generated with specially designed controls included with the kit.",
			"handle": "/products/5-mc-dna-elisa-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5325_5-mC_20DNA_20ELISA_20Kit.png?v=1628532398&width=600",
			"generalIndex": "998",
			"id": "5-mc-dna-elisa-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"non-bisulfite-method",
				"antibody",
			],
			filters: []
		},
		"OneStep PLUS qMethyl PCR Kit": {
			"title": "OneStep PLUS qMethyl PCR Kit",
			"catalogNumbers": "D5312",
			"description": "Enzymatic Real-Time PCR for the detection of DNA methylation.",
			"handle": "/products/onestep-plus-qmethyl-pcr-kit",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/D5312-One-STEP-PLUS-qMethyl-PCR_600x.jpg",
			"generalIndex": "998",
			"id": "onestep-plus-qmethyl-pcr-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"non-bisulfite-method",
			],
			filters: []
		},
		"Methylated-DNA IP Kit": {
			"title": "Methylated-DNA IP Kit",
			"catalogNumbers": "D5101",
			"description": "The Methylated-DNA IP Kit is designed for enrichment of 5mC-containing DNA from any pool of fragmented genomic DNA for use in genome-wide methylation analysis. It features a highly specific Anti-5-Methylcytosine Monoclonal Antibody for the immunoprecipitation of methylated DNA in only a few hours. This kit is capable of achieving over one hundred-fold enrichment of methylated DNA vs. non-methylated DNA. Recovered DNA is suitable for many downstream applications to analyze genome-wide DNA methylation including PCR, bisulfite treatment, whole-genome amplification, ultra-deep sequencing, and microarray. ",
			"handle": "/products/methylated-dna-ip-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5101_Methylated-DNA-IP-Kit.jpg?v=1628532403&width=600",
			"generalIndex": "998",
			"id": "methylated-dna-ip-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"non-bisulfite-method",
				"antibody",
			],
			filters: []
		},
		"Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)": {
			"title": "Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)",
			"catalogNumbers": "A3002-15, A3002-200, A3002-30, A3002-50",
			"description": "The mouse Anti-5-Methylcytosine Monoclonal Antibody specifically recognizes methylated cytosines. The antibody binds to 5-mC in single-stranded DNA, with no detectable cross-reactivity to non-methylated or hydoxymethylated cytosines. This product is ideal for immuno-based assays such as methylated DNA Immunoprecipitation (MeDIP), ELISA and dot blot.",
			"handle": "/products/anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/A3002-50_Anit_20Methylation_20-_201_2ul.png?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"non-bisulfite-method",
				"antibody",
			],
			filters: []
		},
		"Universal Methylated DNA Standard": {
			"title": "Universal Methylated DNA Standard",
			"catalogNumbers": "D5011, D5012",
			"description": "The Universal Methylated DNA Standards are designed to be used as positive controls to assess the efficiency of DNA bisulfite conversion in human and mouse models. The control DNA can be run in parallel with samples to monitor the bisulfite conversion reaction. The primer sets are designed to amplify a fragment of the supplied DNA from the respective species following bisulfite treatment.",
			"handle": "/products/universal-methylated-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5011_Universal-Methylated-Human-DNA-Standard.jpg?v=1628532409&width=600",
			"generalIndex": "998",
			"id": "universal-methylated-dna-standard",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"dna-methylation-standard",
			],
			filters: []
		},
		"Human Methylated & Non-Methylated (WGA) DNA Set": {
			"title": "Human Methylated & Non-Methylated (WGA) DNA Set",
			"catalogNumbers": "D5013, D5013-1, D5013-2",
			"description": "The Human WGA Methylated & Non-methylated DNA Set consists of two control DNAs (non-methylated and methylated) along with a set of specifically designed primers that can be used in conjunction with the EZ DNA Methylation, EZ DNA Methylation-Gold, EZ DNA Methylation-Direct, and EZ DNA Methylation-Lightning kits from Zymo Research to assess the efficiency of bisulfite-mediated conversion of DNA. The Human WGA Methylated & Non-methylated DNA Set is generated using phi29 DNA polymerase based whole genome amplification techniques from HCT116 DKO cell line derived genomic DNA (Human HCT116 DKO Non-methylated DNA). The Human WGA Methylated DNA is Human WGA Non-methylated DNA that has been enzymatically methylated at all double-stranded CG dinucleotides using M.SssI methyltransferase and can be used as a positive control for DNA methylation analysis.",
			"handle": "/products/human-methylated-non-methylated-wga-dna-set-dna-w-primers",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5013_Human-WGA-Methylated-and-Non-Methylated-DNA-Set.jpg?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "human-methylated-non-methylated-wga-dna-set-dna-w-primers",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"dna-methylation-standard",
			],
			filters: []
		},
		"Human Methylated & Non-methylated DNA Set": {
			"title": "Human Methylated & Non-methylated DNA Set",
			"catalogNumbers": "D5014-1, D5014-2, D5014",
			"description": "The Human Methylated & Non-methylated DNA Set consists of two DNA controls (a CpG-methylated human DNA standard and a non-methylated human DNA standard), with a set of specifically designed primers that can be used in conjunction with the EZ DNA Methylation family of products. This DNA set can be included as a positive and negative control to assess the efficiency of bisulfite conversion of DNA. The non-methylated human DNA is purified from the HCT116 DKO cell line, which contains genetic knockouts of both DNA methyltransferases DNMT1 (-/-) and DNMT3b (-/-). The methylated DNA standard is purified HCT116 DKO DNA that has been enzymatically methylated at CpG sites.",
			"handle": "/products/human-methylated-non-methylated-dna-set-dna-w-primers",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5014_Human-Methylated-and-Non-Methylated-DNA-Set.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "human-methylated-non-methylated-dna-set-dna-w-primers",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"dna-methylation-standard",
			],
			filters: []
		},
		"Bisulfite-Converted Universal Methylated Human DNA Standard": {
			"title": "Bisulfite-Converted Universal Methylated Human DNA Standard",
			"catalogNumbers": "D5015",
			"description": "The Bisulfite-Converted Universal Methylated Human DNA Standard is designed to be used as a control for DNA bisulfite conversion and downstream analyses including PCR, MSP, and other amplification-based assays. This DNA is identical to our Universal Methylated Human DNA Standard, but has been bisulfite-converted using the EZ DNA Methylation - Direct (D5020) kit. This product is provided as a 20 ng/µl solution and contains enough for 50 reactions. The primer set included with the standard has been designed and validated to amplify a segment of the bisulfite-converted DNA.",
			"handle": "/products/bisulfite-converted-universal-methylated-human-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5015_Bisulfite-Converted-Universal-Methylated-HUman-DNA-Standard.jpg?v=1628532402&width=600",
			"generalIndex": "998",
			"id": "bisulfite-converted-universal-methylated-human-dna-standard",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"dna-methylation-standard",
			],
			filters: []
		},
		"E. coli Non-Methylated Genomic DNA": {
			"title": "E. coli Non-Methylated Genomic DNA",
			"catalogNumbers": "D5016",
			"description": "E. coli non-methylated genomic DNA is from a Dam- and Dcm- strain (ER2925) of E. coli. It works perfectly as a negative control for DNA methylation analyses requiring DNA with absolutely no methylation.",
			"handle": "/products/e-coli-non-methylated-genomic-dna",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5016_E-Coli-Non-Methylated-Genomic-DNA.jpg?v=1628532395&width=600",
			"generalIndex": "998",
			"id": "e-coli-non-methylated-genomic-dna",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"dna-methylation-standard",
			],
			filters: []
		},
		"Methylated & Non-methylated pUC19 DNA Set": {
			"title": "Methylated & Non-methylated pUC19 DNA Set",
			"catalogNumbers": "D5017",
			"description": "The Methylated & Non-methylated pUC19 DNA Set consists of control DNAs and a set of specifically designed primers. The set is ideal as a “spike-in” control to assess bisulfite conversion efficiency within the same reaction as the sample, or to produce known mixtures of methylated and non-methylated DNA for assay calibration. The non-methylated pUC19 DNA is pUC19 isolated from a methylation-negative strain of bacteria (Dam-, Dcm-), and the methylated pUC19 DNA is pUC19 enzymatically methylated at all cytosines in the dinucleotide sequence 5'...CpG...3' by CpG Methylase.",
			"handle": "/products/methylated-non-methylated-puc19-dna-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5017_Methylated-and-Non-Methylated-pUC19-DNA-Set.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "methylated-non-methylated-puc19-dna-set",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"dna-methylation-standard",
			],
			filters: []
		},
		"Human Matched DNA Set": {
			"title": "Human Matched DNA Set",
			"catalogNumbers": "D5018, D5018-1, D5018-2",
			"description": "The Human Matched DNA Set is a set of organ specific human genomic DNAs originating from a single individual. This set is an ideal control for detection and/or quantification methods against 5-methylcytosine and 5-hydroxymethylcytosine as both modified cytosines are present at physiologically relevant levels and loci. The levels of 5-hydroxymethylcytosine and 5-methylcytosine within the Human Matched DNA Set have been quantified via LC/MS.",
			"handle": "/products/human-matched-dna-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5018_Human-Matched-DNA-Set.jpg?v=1628532387&width=600",
			"generalIndex": "998",
			"id": "human-matched-dna-set",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"dna-methylation-standard",
			],
			filters: []
		},
		"Mouse 5-hmC & 5-mC DNA Set": {
			"title": "Mouse 5-hmC & 5-mC DNA Set",
			"catalogNumbers": "D5019-1, D5019-2, D5019-3, D5019-4, D5019",
			"description": "The Mouse 5-hmC & 5-mC DNA Set is a set of organ specific mouse genomic DNAs isolated from a pool of 8-10 week old Swiss Webster mice. This genomic DNA set is an ideal control for detection and/or quantification methods against 5-methylcytosine and 5-hydroxymethylcytosine as both modified cytosines are present at physiologically relevant levels and loci. The levels of 5-mC and 5-hmC within the Mouse 5-hmC & 5-mC DNA Set have been precisely quantified by mass spectrometry (LC/MS) and been validated to be consistent by ELISA.",
			"handle": "/products/mouse-5hmc-5mc-dna-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5019_Mouse-hmC-and-5-mC-DNA.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "mouse-5hmc-5mc-dna-set",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"5-hmc",
				"dna-methylation-standard",
			],
			filters: []
		},
		"5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set": {
			"title": "5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set",
			"catalogNumbers": "D5405",
			"description": "The 5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set is a set of three standards that are linear dsDNA at a length of 897 bp. All DNA standards have the same sequence (see protocol for sequence), the only difference being that each standard contains either 100% unmodified cytosines, 5-methylcytosines, or 5-hydroxymethylcytosines. Since the sequence and extent of cytosine modification is known, this DNA standard set is ideal for use in calibration of various applications intended for quantitation of cytosine modifications.",
			"handle": "/products/5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5405_5-mC_20_205-hmC_20DNA_20Standard_20Set.png?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"5-hmc",
				"dna-methylation-standard",
			],
			filters: []
		},
		"Zymo-Seq Methyl Spike-in Control": {
			"title": "Zymo-Seq Methyl Spike-in Control",
			"catalogNumbers": "D5500",
			"description": "Zymo-Seq Methyl Spike-in Control is comprised of six unique double-stranded synthetic amplicons (180-200 bp) with distinct sequences derived from the E. coli K12 genome, and each amplicon represents a different CpG methylation level ranging from 0% to 100%.",
			"handle": "/products/zymo-seq-methyl-spike-in-control",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D5500-Zymo-Seq_Methyl_Spike-in_Control_600x.jpg",
			"generalIndex": "998",
			"id": "zymo-seq-methyl-spike-in-control",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"dna-methylation-standard",
			],
			filters: []
		},
		"OneStep qMethyl-PCR Kit": {
			"title": "OneStep qMethyl-PCR Kit",
			"catalogNumbers": "D5310, D5311",
			"description": "The OneStep qMethyl Kit provides a simple, straightforward, and bisulfite-free procedure for rapid, locus-specific DNA methylation assessment via the selective amplification of a methylated region of DNA. This is accomplished by splitting any DNA to be tested into two parts: a “Test Reaction” and a “Reference Reaction”. DNA in the Test Reaction is digested with Methylation Sensitive Restriction Enzymes (MSREs) while DNA in the Reference Reaction is not. The DNA from both samples is then amplified using real-time PCR in the presence of SYTO 9 fluorescent dye and quantitated using a simple equation.",
			"handle": "/products/onestep-qmethyl-pcr-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5310_OneStep-qMethyl.jpg?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "onestep-qmethyl-pcr-kit",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"non-bisulfite-method",
			],
			filters: []
		},
		"ZymoTaq Premix": {
			"title": "ZymoTaq Premix",
			"catalogNumbers": "E2003, E2004",
			"description": "ZymoTaq PreMix is supplied as a 2X concentrated “master mix” containing all the reagents needed to perform “hot start” PCR. The inclusion of a heat-activated, thermal-stable DNA polymerase reduces primer dimer and non-specific product formation that can occur when performing conventional PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2003_ZymoTaq-PreMix.jpg?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "zymotaq-premix",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase": {
			"title": "ZymoTaq DNA Polymerase",
			"catalogNumbers": "E2001, E2002",
			"description": "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. The inclusion of a heat-activated, thermostable DNA polymerase reduces primer dimer and nonspecific product formation that can occur during PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR. ",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-dna-polymerase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2001_ZymoTaq-Polymerase.jpg?v=1628532372&width=600",
			"generalIndex": "998",
			"id": "zymotaq-dna-polymerase",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"ZymoTaq qPCR Premix": {
			"title": "ZymoTaq qPCR Premix",
			"catalogNumbers": "E2054, E2055",
			"description": "ZymoTaq qPCR PreMix contains all the reagents needed to perform quantitative PCR and other molecular downstream analysis such as high-resolution melt (HRM) analysis of DNA methylation and other general real-time PCR assays. This premix features a hot-start DNA polymerase and buffer system optimized for the amplification of bisulfite-treated DNA. It also includes an intense dsDNA-specific fluorescent dye, SYTO 9, for sensitive real-time DNA quantification.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-qpcr-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2054_ZymoTaq-qPCR-Premix.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "zymotaq-qpcr-premix",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"Quest 5-hmC DNA ELISA Kit": {
			"title": "Quest 5-hmC DNA ELISA Kit",
			"catalogNumbers": "D5425, D5426",
			"description": "The Quest 5-hmC DNA ELISA Kit is both sensitive and specific and can be used to accurately detect 5-hmC DNA in a variety of samples. The kit is compatible with a wide range of input DNA including intact vertebrate, plant, and microbial genomic DNA, as well as enzyme-digested and mechanically sheared fragments. The Control DNA Set included with this kit has been calibrated to accurately quantify the percent 5-hmC in sample DNA by use of a standard curve. Also, the fast, streamlined workflow is ideal when analyzing/screening large numbers of samples.",
			"handle": "/products/quest-5-hmc-dna-elisa-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5425_Quest_205-hmC_20DNA_20ELISA_20Kit.png?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "quest-5-hmc-dna-elisa-kit",
			"tags": [
				"5-hmc",
				"antibody",
			],
			filters: []
		},
		"Anti-5-Hydroxymethylcytosine Polyclonal Antibody": {
			"title": "Anti-5-Hydroxymethylcytosine Polyclonal Antibody",
			"catalogNumbers": "A4001-200, A4001-25, A4001-50",
			"description": "The rabbit Anti-5-hmC Polyclonal Antibody can robustly distinguish between hydroxymethylated DNA and methylated or unmodified DNA with limited to no cross-reactivity. The antibody has been validated in ELISA and immunoprecipitation-based enrichment assays, and is suitable for use in further applications including immunohistochemical labeling and chromatographic blotting.",
			"handle": "/products/anti-5-hydroxymethylcytosine-polyclonal-antibody",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/A4001-25_Anti-5-Hydroxymethylcytosine_20Polyclonal_20Antibody_20-_2025_20ug.png?v=1628532400&width=600",
			"generalIndex": "998",
			"id": "anti-5-hydroxymethylcytosine-polyclonal-antibody",
			"tags": [
				"5-hmc",
				"antibody",
			],
			filters: []
		},
		"RRHP 5-hmC Library Prep Kit": {
			"title": "RRHP 5-hmC Library Prep Kit",
			"catalogNumbers": "D5450, D5451",
			"description": "The RRHP 5-hmC Library Prep Kit is an all-inclusive solution for analysis of genome-wide 5-hydroxymethylcytosine (5-hmC) positions at single-base resolution. The Reduced Representation Hydroxymethylation Profiling (RRHP) method is based on blocking MspI digestion by glucosylating 5-hmC within MspI recognition sites. Fragments lacking glucosylated 5-hmC at the adapter-ligation junction will be cleaved and not amplified by PCR. Therefore, only fragments containing 5-hmC will be successfully amplified and analyzed by Next-Generation Sequencing. ",
			"handle": "/products/rrhp-5-hmc-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5450_RRHP_205-hmC_20Library_20Prep_20Kit.png?v=1628532403&width=600",
			"generalIndex": "998",
			"id": "rrhp-5-hmc-library-prep-kit",
			"tags": [
				"5-hmc",
				"non-bisulfite-method",
				"ngs-library-prep",
			],
			filters: []
		},
		"DNA Degradase Plus": {
			"title": "DNA Degradase Plus",
			"catalogNumbers": "E2020, E2021",
			"description": "DNA Degradase Plus from Zymo Research is a nuclease mix that quickly and efficiently degrades DNA to its individual nucleoside components. Since nucleosides lack negatively charged phosphate, DNA Degradase Plus is ideal for whole-genome DNA methylation analysis by LC/MS. Digestion with the enzyme is performed via a one-step procedure that is faster and simpler than other available methods.",
			"handle": "/products/dna-degradase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2020_DNA-Degradase-Plus.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dna-degradase-plus",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"Zymo-Spin ChIP Kit": {
			"title": "Zymo-Spin ChIP Kit",
			"catalogNumbers": "D5209, D5210",
			"description": "The Zymo-Spin ChIP Kit from Zymo Research provides a streamlined ChIP procedure for investigating protein-DNA interactions that have been “fixed” in their natural state and can be used to effectively identify binding sites for transcription factors, co-factors, and other DNA regulatory proteins.",
			"handle": "/products/zymo-spin-chip-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5209_Zymo-Spin-ChIP-Kit.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "zymo-spin-chip-kit",
			"tags": [
				"chromatin",
				"non-bisulfite-method",
				"antibody",
				"column",
			],
			filters: []
		},
		"ChIP DNA Clean & Concentrator": {
			"title": "ChIP DNA Clean & Concentrator",
			"catalogNumbers": "D5205, D5201",
			"description": "The Chromatin Immunoprecipitation (ChIP) DNA Clean & Concentrator provides a hassle-free method for the rapid purification and concentration of high-quality DNA from any step in a standard ChIP protocol. This includes samples that have undergone reverse cross-linking, Proteinase K or RNase A digestion, mechanical or nuclease-mediated DNA shearing, and samples eluted from chromatin-antibody-bead complexes. The specially formulated ChIP DNA Binding Buffer promotes DNA adsorption to the column in the presence of detergents, antibodies, and proteinases that are often used for ChIP.",
			"handle": "/products/chip-dna-clean-concentrator",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5201_ChIP-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "chip-dna-clean-concentrator",
			"tags": [
				"chromatin",
				"non-bisulfite-method",
				"antibody",
				"column",
			],
			filters: []
		},
		"ZR-96 ChIP DNA Clean & Concentrator": {
			"title": "ZR-96 ChIP DNA Clean & Concentrator",
			"catalogNumbers": "D5206, D5207",
			"description": "The ZR-96 Chromatin Immunoprecipitation (ChIP) DNA Clean & Concentrator provides a hassle-free method for the rapid, high-throughput purification, and concentration of high-quality DNA from any step in a standard ChIP protocol. This product is well suited for samples that have undergone reverse cross-linking and Proteinase K or RNase A digestion as well as reverse cross-linked samples eluted from chromatin-antibody-bead complexes. Additionally, this product may also be used to purify DNA from PCR and other enzymatic reactions. DNA purified using the ZR-96 ChIP DNA Clean & Concentrator ™ is suitable for PCR, Next-Gen sequencing (ChIP-Seq), arrays, as well as other molecular applications.",
			"handle": "/products/zr-96-chip-dna-clean-concentrator",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5206_ZR-96-ChIP-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "zr-96-chip-dna-clean-concentrator",
			"tags": [
				"chromatin",
				"non-bisulfite-method",
				"antibody",
				"spin-plate",
			],
			filters: []
		},
		"EZ Nucleosomal DNA Prep Kit": {
			"title": "EZ Nucleosomal DNA Prep Kit",
			"catalogNumbers": "D5220",
			"description": "The EZ Nucleosomal DNA Prep Kit is a streamlined procedure for the isolation of nucleosome-associated DNA. The kit includes reagents/procedures for the following: cell nuclei isolation, intact nuclei enzymatic digestion, and nucleosomal DNA purification. This kit includes two different enzymes for nucleosomal DNA preparation: Atlantis dsDNase and Micrococcal Nuclease. Enzymatic digestion yields very homogeneous populations of core nucleosomes and purification of the nucleosome-associated DNA is performed using Zymo Research’s proven spin column technology. ",
			"handle": "/products/ez-nucleosomal-dna-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5220_EZ-Nucleosomal-DNA-Prep-Kit.jpg?v=1628532399&width=600",
			"generalIndex": "998",
			"id": "ez-nucleosomal-dna-prep-kit",
			"tags": [
				"chromatin",
				"enzyme",
			],
			filters: []
		},
		"Zymo-Seq ATAC Library Kit": {
			"title": "Zymo-Seq ATAC Library Kit",
			"catalogNumbers": "D5458",
			"description": "Zymo-Seq ATAC Library Kit provides a simple and streamlined workflow for Assay for Transposase Accessible Chromatin with high throughput Sequencing (ATAC-Seq) library preparation from mammalian cell and tissue input. This all-inclusive kit features an easy to follow protocol capable of preparing ATAC-Seq libraries from as little as 50,000 cells in as little as 4 hours with minimal hands on time.",
			"handle": "/products/zymo-seq-atac-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5458-Zymo-Seq-ATAC-Library-Kit_2365_002_ProductPhoto.jpg?v=1677624838&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-atac-library-kit",
			"tags": [
				"chromatin",
				"ngs-library-prep",
			],
			filters: []
		},
		"DNA Degradase": {
			"title": "DNA Degradase",
			"catalogNumbers": "E2016, E2017",
			"description": "DNA Degradase from Zymo Research is a nuclease mix that quickly and efficiently degrades DNA to its individual nucleotide components. DNA Degradase is ideal for whole-genome DNA methylation analysis by many downstream applications (i.e., HPLC, TLC, etc.). Digestion with the enzyme is performed via a one-step procedure that is faster and simpler than other available methods.",
			"handle": "/products/dna-degradase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2016_DNA-Degradase.jpg?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "dna-degradase",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"Atlantis dsDNase": {
			"title": "Atlantis dsDNase",
			"catalogNumbers": "E2030",
			"description": "Atlantis dsDNase is a double-stranded DNA-specific endonuclease that cleaves phosphodiester bonds in DNA to yield homogeneous populations of core nucleosomes.",
			"handle": "/products/atlantis-ds-dnase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2030_Atlantis-dsDNase-12.5-U.jpg?v=1628532394&width=600",
			"generalIndex": "998",
			"id": "atlantis-ds-dnase",
			"tags": [
				"chromatin",
				"enzyme",
			],
			filters: []
		},
		"Micrococcal Nuclease": {
			"title": "Micrococcal Nuclease",
			"catalogNumbers": "D5220-1",
			"description": "Cleaves single-stranded and double-stranded DNA and RNA. Complete digestion with Micrococcal Nuclease yields mono- and oligonucleotides with 3'-phosphates.",
			"handle": "/products/micrococcal-nuclease",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5220-1_Micrococcal-Nuclease.jpg?v=1628532397&width=600",
			"generalIndex": "998",
			"id": "micrococcal-nuclease",
			"tags": [
				"chromatin",
				"enzyme",
			],
			filters: []
		},
		"dsDNA Shearase Plus": {
			"title": "dsDNA Shearase Plus",
			"catalogNumbers": "E2018-50, E2018-200",
			"description": "dsDNA Shearase Plus is an endonuclease that cleaves phosphodiester bonds in DNA to yield oligonucleotides with 5'-phosphate and 3'-hydroxyl termini. It has a particularly strong preference for dsDNA and generates random-ended DNA fragments of the desired size in a single step. This enzyme is compatible with low volume inputs, thus minimizing sample loss.",
			"handle": "/products/dsdna-shearase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2018-50_dsDNA-Shearase-Plus-50-U.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "dsdna-shearase-plus",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"CpG Methylase (M. Sssl)": {
			"title": "CpG Methylase (M. Sssl)",
			"catalogNumbers": "E2010, E2011",
			"description": "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
			"handle": "/products/cpg-methylase-m-sssl",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2010_CpG-Methylase.jpg?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "cpg-methylase-m-sssl",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"5-hmC Glucosyltransferase": {
			"title": "5-hmC Glucosyltransferase",
			"catalogNumbers": "E2026, E2027",
			"description": "5-hmC detection; 5-hmC enrichment",
			"handle": "/products/5-hmc-glucosyltransferase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2026_5-hmC-Glucosyltransferase.jpg?v=1628532397&width=600",
			"generalIndex": "998",
			"id": "5-hmc-glucosyltransferase",
			"tags": [
				"5-hmc",
				"enzyme",
			],
			filters: []
		},
		"5-Methyl dCTP": {
			"title": "5-Methyl dCTP",
			"catalogNumbers": "D1035",
			"description": "Modified deoxynucleotide for use with PCR, mass spec, etc.",
			"handle": "/collections/methylated-nucleotides/products/5-methyl-dctp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1035_Methylated-and-Hydroxymethylated-Nucleotides.jpg?v=1628532399&width=600",
			"generalIndex": "998",
			"id": "5-methyl-dctp",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"5-Methylcytosine dNTP Mix": {
			"title": "5-Methylcytosine dNTP Mix",
			"catalogNumbers": "D1030",
			"description": "dNTP mixture containing the modified deoxynucleotide 5-mC for use with PCR, mass spec, etc.",
			"handle": "/collections/methylated-nucleotides/products/5-methylcytosine-dntp-mix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "5-methylcytosine-dntp-mix",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"dNTP Mix": {
			"title": "dNTP Mix",
			"catalogNumbers": "D1000, D1000-1",
			"description": "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/collections/dntp-solutions/products/dntp-mix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1000_dNTPs.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dntp-mix",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"dCTP": {
			"title": "dCTP",
			"catalogNumbers": "D1020",
			"description": "Ultra pure dCTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dctp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1020_dCTP.jpg?v=1628532398&width=600",
			"generalIndex": "998",
			"id": "dctp",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"dATP": {
			"title": "dATP",
			"catalogNumbers": "D1005",
			"description": "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/collections/dntp-solutions/products/datp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1005_dATP.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "datp",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"dTTP": {
			"title": "dTTP",
			"catalogNumbers": "D1010",
			"description": "dTTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/collections/dntp-solutions/products/dttp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1010_dTTP.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "dttp",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
		"dGTP": {
			"title": "dGTP",
			"catalogNumbers": "D1015",
			"description": "dGTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/collections/dntp-solutions/products/dgtp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1015_dGTP.jpg?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "dgtp",
			"tags": [
				"dna-rna-methylation-(5-mc)",
				"enzyme",
			],
			filters: []
		},
	}
}